import Inherit from '../../core/inherit';
import SignupDelegate from './signup.delegate';
import ValidationController from '../../core/validation.controller';
/**
 * @extends ValidationController
 * @extends SignupDelegate
 */
class SignupController extends Inherit(ValidationController, SignupDelegate) {
    async initialize() {
        // Check if user is already authenticated
        if (this.user && this.user.access && this.user.access.length > 0) {
            this.navigateDashboard();
            return;
        }
        await this.tokenInitialize();
    }

    async createAccount() {
        try {
            this.setState({ loading: true, error: false });
            
            const response = await this.data.registerUser(this.state);
            
            if (response?.id) {                
                // Transition to success screen
                this.setState({ loading: false, showSuccessScreen: true });
            }
        } catch (error) {
            const message = error?.response?.data?.error || 'Something went wrong. Please try again.';
            this.setState({ error: true, loading: false });
            this.props.notificationApi.error({
                message: 'Account creation failed',
                description: message,
            });
        }
    }
}

export default SignupController;

